import { useWeb3Onboard } from '../context.js';
export var useSetLocale = function useSetLocale() {
  return useWeb3Onboard().state.actions.setLocale;
};